import React from 'react'
import NavbarDashboard from '../../components/Admin/NavbarDashboard/NavbarDashboard'
export default function Header() {
    return (
        <div>
            <NavbarDashboard />

        </div>
    )
}
